import countries from "../modules/vuetifyx/utils/countries"

class PhoneNumber {
  public getCountryCodes() {
    const items = countries.map(country => ({'text': country[1], 'value': country[2]}))
    return items
  }

}

export default new PhoneNumber()
